import React from 'react';
import { Button } from '../ui/Button';
import { PhoneIcon } from 'lucide-react';
export function CTABanner() {
  return <section className="bg-[#0B1F3A] text-white py-16" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4" data-id="element-63">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-64">
          <div className="text-center md:text-left" data-id="element-65">
            <h2 className="text-3xl lg:text-4xl font-bold mb-4" data-id="element-66">
              Ready to Book Your Medical Transport?
            </h2>
            <p className="text-xl text-gray-300" data-id="element-67">
              Call us now or book online for fast, reliable service
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-68">
            <Button variant="primary" size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-69">
              Contact Us
            </Button>
            <div className="flex flex-col gap-2" data-id="element-70">
              <a href="tel:2405653357" className="flex items-center text-xl font-bold hover:text-[#E63946] transition-colors" data-id="element-71">
                <PhoneIcon className="h-6 w-6 mr-2" data-id="element-72" />
                240-565-3357
              </a>
              <a href="tel:3014300712" className="flex items-center text-lg text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-73">
                <PhoneIcon className="h-5 w-5 mr-2" data-id="element-74" />
                301-430-0712
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}